import React, { useRef, useState } from "react";
import Flags from "./Flags";
import Tooltips from "./Tooltips";
import { handleState } from "../../Utils/utils";
import IconTableDown from "../../Resources/svg/Icons/IconTableDown";
import IconOptions from "../../Resources/svg/Icons/IconOptions";
import IconCloseOptions from "../../Resources/svg/Icons/IconCloseOptions";
import Loading from "../loading";

const CardTablaRV = ({
  data,
  confirmToQuote,
  logRequest,
  generatePdfQuote,
  goToDetail,
  goToModalities,
  checkboxActive,
  itemIndex,
  handleOnChange,
}) => {
  const [collapse, setCollapse] = useState(false);
  const [showoptions, setShowOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [linkPdf, setLinkPdf] = useState("");
  const elem = useRef(null);

  const {
    nroOperacion,
    CUSPP,
    afiliado: { nroDoc },
    fechaCargaXML,
    fechaCierre,
    estado,
    descripcionEstado,
    fondo: { capitalPension },
  } = data || null;

  const handleCardStateTable = () => {
    setCollapse((c) => !c);
  };

  const hanldeOpenMenu = () => {
    setShowOptions(true);
    document.body.style.overflow = "hidden";
  };

  const hanldeCloseMenuCard = () => {
    setShowOptions(false);
    document.body.style.overflow = "auto";
  };

  const availableBottons = (item) => {
    const actions = {
      quote: false,
      pdf: true,
      log: false,
    };

    switch (item.estado) {
      case "ingresado":
        actions.pdf = false;
        break;
      case "ingresadoRp":
        actions.pdf = false;
        actions.quote = true;
        break;
      case "errorCotizacion":
        actions.log = true;
        actions.pdf = false;
        break;
      case "anulado":
        actions.pdf = false;
        break;
      default:
        break;
    }

    return actions;
  };

  return (
    <div className="card-table">
      <a
        style={{ display: "none" }}
        target="_blank"
        rel="noopener noreferrer"
        href={linkPdf}
        ref={elem}
      />
      <div className="flag-state-info">
        <Flags variant={estado}>{handleState(estado)}</Flags>
        <Tooltips text={descripcionEstado} />
      </div>
      <div className={`card-table__icon`} onClick={hanldeOpenMenu}>
        <IconOptions />
      </div>
      <div className="card-table__checkbox">
        <label>
          <input
            type="checkbox"
            name={`checkbox_${itemIndex}`}
            className="filled-in"
            checked={checkboxActive}
            onChange={handleOnChange}
          />
          <span></span>
        </label>
      </div>
      <div className="card-table__box">
        <div className="card-table__description">N° Operación:</div>
        <div className="card-table__data">{nroOperacion}</div>
        <div className="card-table__description">CUSPP:</div>
        <div className="card-table__data">{CUSPP}</div>
        <div className="card-table__description">DNI / CE:</div>
        <div className="card-table__data">{nroDoc}</div>
        {collapse && (
          <>
            <div className="card-table__description">Fec. Carga:</div>
            <div className="card-table__data">{fechaCargaXML}</div>
            <div className="card-table__description">Fec. Cierre:</div>
            <div className="card-table__data">{fechaCierre}</div>
            <div className="card-table__description">Total Cap. Pensión:</div>
            <div className="card-table__data">{capitalPension}</div>
          </>
        )}
        <div className="card-table__options" onClick={handleCardStateTable}>
          {collapse ? "Mostrar menos" : "Mostrar más"}
          <IconTableDown className={`${collapse ? "up" : "down"}`} />
        </div>
      </div>
      <div className="menu">
        <div className={`menu__box ${showoptions ? "open-options" : ""}`}>
          <div className="header-card">
            <div className="header-card__title">
              Más opciones{" "}
              <span onClick={hanldeCloseMenuCard}>
                <IconCloseOptions />
              </span>
            </div>
          </div>
          <div className="menu__options">
            {availableBottons(data).quote && (
              <div
                className="menu__buttons"
                onClick={() => confirmToQuote(data)}
              >
                <div>Cotizar</div>
              </div>
            )}
            {availableBottons(data).log && (
              <div className="menu__buttons" onClick={() => logRequest(data)}>
                <div>Log</div>
              </div>
            )}
            {availableBottons(data).pdf && data.respuestaECM && data.respuestaECM.cartaAFP && 
              ['emitida', 'cartaEnviada', 'datosActualizados', 'enviadoEmision', 'recalculado'].includes(estado) && (
              <div className="menu__buttons" onClick={() => window.open(data.respuestaECM.cartaAFP.documents.fileUrl, "_blank")}>
                <div>Mostrar Carta AFP</div>
              </div>
            )}
            {availableBottons(data).pdf && (
              <div className="menu__buttons" onClick={() => generatePdfQuote()}>
                <div>Descargar</div>
              </div>
            )}
            <div className="menu__buttons" onClick={() => goToDetail(data)}>
              <div>Detalle</div>
            </div>
            <div className="menu__buttons" onClick={() => goToModalities(data)}>
              <div>Modalidades</div>
            </div>
          </div>
        </div>
        <div
          className={`menu__background ${showoptions ? "open-options" : ""}`}
        ></div>
      </div>

      {isLoading && <Loading />}
    </div>
  );
};

export default CardTablaRV;
